import React from "react";
import { fmtInt } from "@/lib/billing";

const KIND_LABEL = {
  debit: "Used", topup: "Top-up", included_reset: "Monthly reset", adjust: "Admin adjustment",
  swap_in: "Swap in", swap_out: "Swap out", clawback: "Refund claw-back", grant: "Grant",
};

export default function UsageHistory({ rows, title = "Usage history", testid = "usage-history", compact = false }) {
  return (
    <section className={compact ? "" : "rounded-lg border border-slate-200 bg-white p-5"} data-testid={testid}>
      {!compact ? <h2 className="text-base md:text-lg font-semibold text-slate-900">{title}</h2> : null}
      {!rows?.length ? (
        <p className="text-sm text-slate-500 mt-2">No credit movements yet.</p>
      ) : (
        <div className="mt-3 overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-[11px] uppercase tracking-wider text-slate-500 border-b border-slate-100">
                <th className="py-2 pr-3">When</th>
                <th className="py-2 pr-3">What</th>
                <th className="py-2 pr-3">Pool</th>
                <th className="py-2 pr-3 text-right">Credits</th>
                <th className="py-2 text-right">Balance</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id} className="border-b border-slate-50 last:border-0" data-testid={`usage-row-${r.id}`}>
                  <td className="py-2 pr-3 text-xs text-slate-500 whitespace-nowrap">{new Date(r.created_at).toLocaleString("en-CA", { dateStyle: "medium", timeStyle: "short" })}</td>
                  <td className="py-2 pr-3 text-slate-800">
                    {KIND_LABEL[r.kind] || r.kind}{r.feature ? ` · ${r.feature}` : ""}
                    {r.note ? <span className="block text-[11px] text-slate-500">{r.note}</span> : null}
                  </td>
                  <td className="py-2 pr-3 text-xs capitalize text-slate-600">{r.pool}</td>
                  <td className={"py-2 pr-3 text-right tabular-nums font-medium " + (r.delta < 0 ? "text-slate-900" : "text-emerald-700")}>
                    {r.delta > 0 ? "+" : ""}{fmtInt(r.delta)}
                  </td>
                  <td className="py-2 text-right tabular-nums text-slate-500">{fmtInt(r.balance_after)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
